const isOpenByMyHKBNApp = navigator.userAgent.indexOf('MyHKBNApp') > -1;
// const MYHKBN_API = isOpenByMyHKBNApp ? '' : '/myhkbn-api';
// const MYHKBN_API = isOpenByMyHKBNApp ? '' : '/digital/api';
// const MYHKBN_API = isOpenByMyHKBNApp ? '' : '/myhkbn-login/api';
const MGMPORTAL_API = '/mgm-portal-api';

/**
 * API URL
 */
const API = {
    // GET_ONLINE_CAMPAIGN_TEMP_KEY: MYHKBN_API + '/order/onlineCampaign/link',
    // GET_ONLINE_CAMPAIGN_INFO: MYHKBN_API + '/order/onlineCampaign/getPlanInfo',
    // SUBMIT_BN_CHANGE_PLAN_XE_UPSELL_ORDER: MYHKBN_API + '/order/ret/bnXe/chgPlanUpsell',
    // SEND_ONLINE_CAMPAIGN_SMS_VERIFICATION_CODE: MYHKBN_API + '/mobile/smsCode/onlineCampaign/verificationCode',
    // VALIDATE_ONLINE_CAMPAIGN_SMS_VERIFICATION_CODE:
    //     MYHKBN_API + '/mobile/smsCode/onlineCampaign/verificationCode/validation',
    // GET_MAINT_CONFIG: MYHKBN_API + '/config/web_digital_online_campaign_maint.json',
    // GET_ONLINE_CAMPAIGN_TEMP_KEY_V2: MYHKBN_API + '/order/onlineCampaign/link/v2',
    // GET_ONLINE_CAMPAIGN_INFO_V2: MYHKBN_API + '/order/onlineCampaign/getPlanInfo/v2',
    // GET_TNC_CONTENT: MYHKBN_API + '/order/onlineCampaign/tnc',
    // GET_TNC_CONTENT_V2: MYHKBN_API + '/order/onlineCampaign/tnc/v2',
    // SUBMIT_CHANGE_PLAN_UPSELL_ORDER: MYHKBN_API + '/order/ret/bnXe/chgPlanUpsell/v2',
    // GET_ONLINE_CAMPAIGN_FLOW_TYPE: MYHKBN_API + '/order/onlineCampaign/flow',
    GET_COMMON_CONTENT: MGMPORTAL_API + '/common/content',
    GET_ACCOUNT_LOGIN: MGMPORTAL_API + '/account/login',
    GET_MGM_CODE: MGMPORTAL_API + '/getMgmcode/token',
    DOWNLOAD_IMAGE: MGMPORTAL_API + '/downloadImage',
    GET_REFERRAL_LOGIN: MGMPORTAL_API + '/referral/check-promo-code',
    GET_ORANGE_BAR_MGM_CODE: MGMPORTAL_API + '/orangeBar/getReferralCode'
};
const API_ENV = REACT_APP_API_URL_ENV;

export default {
    API,
    API_ENV,
    MGMPORTAL_API,
};
